<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <!-- <el-input style="width: 180px" v-model="queryForm.userId"></el-input> -->
                  <GridSelect
                      title='选择用户'
                      labelName='userName'
                      labelValue='id'
                      :value='queryForm.userId'
                      :limit='1'
                      style='width: 180px'
                      size='small'
                      placeholder='请选择用户'
                      @getValue='getValue1'
                      :columns="USER_code"
                      :searchs="USER_search"
                      dataListUrl='/mpp/user/findList'
                      entityBeanName='mppUser'
                      queryEntityUrl='/mpp/user/get'
                  >
                  </GridSelect>
              </el-form-item>
              <el-form-item label="合同">
                  <!-- <el-input style="width: 180px" v-model="queryForm.contractId"></el-input> -->
                  <el-select
                      style="width: 180px;"
                      clearable
                      v-model='queryForm.contractId'
                      size='small'
                      placeholder='请选择合同'
                  >
                    <el-option v-for='(item,index) in AgentLevelAll' :label='item.contractName' :value='item.id'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="文本字段">
                  <el-input style="width: 180px" v-model="queryForm.textFields"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEsignRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEsignRecord"
        >新建</el-button> -->
        <!-- <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEsignRecord(null)"
        >修改</el-button> -->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEsignRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportEsignRecordList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEsignRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="esignRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                  <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                  <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                  <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contractId"
        label="合同"
        width="180"
      >
        <template slot-scope="scope">
          {{ returnGetList(scope.row.contractId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="textFields"
        label="文本字段"
        width="180"
      >
        <template slot-scope="scop">
          <div style="text-align: left;" v-for="item in items(scop.row.textFields)">
            {{ item.key }} : {{ item.value }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signImage"
        label="签名图片"
        width="180"
      >
        <template slot-scope="scope">
          <div v-if='scope.row.signImage'>
            <el-image @click='updateSrcList(scope.row.signImage)' style="width: 60px; height: 60px"
              :src="scope.row.signImage" :preview-src-list="srcList"> </el-image>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="stampImage"
        label="签章图片"
        width="180"
      >
        <template slot-scope="scope">
          <div v-if='scope.row.stampImage'>
            <el-image @click='updateSrcList(scope.row.stampImage)' style="width: 60px; height: 60px"
              :src="scope.row.stampImage" :preview-src-list="srcList"> </el-image>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contractFile"
        label="合同文件"
        width="180"
      >
        <template slot-scope="scope">
          <span class="downloadFile" @click='downloadFile(scope.row.contractFile,scope.row.contractId)'>查看合同</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="签约时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEsignRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <!-- <div @click="editEsignRecord(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div> -->
            <div @click="deleteEsignRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="esignRecordStates[esignRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="esignRecord"
          ref="esignRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              style="width: 180px"
              v-model="esignRecord.userId"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <GridSelect
                title='选择用户'
                labelName='userName'
                labelValue='id'
                :value='esignRecord.userId'
                :disabled="esignRecordState == 'check'"
                :limit='1'
                style='width: 180px'
                size='small'
                placeholder='请选择用户'
                @getValue='getValue'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl='/mpp/user/findList'
                entityBeanName='mppUser'
                queryEntityUrl='/mpp/user/get'
            >
            </GridSelect>
          </el-form-item>
          <el-form-item
            label="合同"
            prop="contractId"
          >
            <!-- <el-input
              size="small"
              style="width: 180px"
              v-model="esignRecord.contractId"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 180px;"
                clearable
                v-model='esignRecord.contractId'
                :disabled="esignRecordState == 'check'"
                size='small'
                placeholder='请选择合同'
            >
              <el-option v-for='(item,index) in AgentLevelAll' :label='item.contractName' :value='item.id'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="文本字段"
            prop="textFields"
          >
            <!-- <el-input
              size="small"
              style="width: 180px"
              v-model="esignRecord.textFields"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <textField size="small"
              style="width: 180px"
              placeholder="请输入字段"
              :feild="{key:true,value:false,btn:true}"
              @getValue="getTextFieldValue"
              :value="esignRecord.textFields"
              :disabled="esignRecordState == 'check'">
            </textField>
          </el-form-item>
          <el-form-item
            label="签名图片"
            prop="signImage"
          >
            <!-- <el-input
              size="small"
              v-model="esignRecord.signImage"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
              :disabled="esignRecordState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage">
              <img v-if="esignRecord.signImage" :src="esignRecord.signImage" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="签章图片"
            prop="stampImage"
          >
            <!-- <el-input
              size="small"
              v-model="esignRecord.stampImage"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
              :disabled="esignRecordState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage1">
              <img v-if="esignRecord.stampImage" :src="esignRecord.stampImage" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="合同文件"
            prop="contractFile"
          >
            <!-- <el-input
              size="small"
              v-model="esignRecord.contractFile"
              :disabled="esignRecordState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload1"
              :disabled="esignRecordState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage2">
              <img v-if="esignRecord.contractFile" :src="esignRecord.contractFile" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="esignRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, USER_SEARCH } from '@/utils/constant.js';
import GridSelect from '@/components/gridselect/index.vue';
import textField from '@/components/Contract/textField.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        textField
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEsignRecordList();
                    this.getEsignRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEsignRecordList();
                    this.getEsignRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     contractId: '', //合同
                     textFields: '', //文本字段
                     signImage: '', //签名图片
                     stampImage: '', //签章图片
                     contractFile: '', //合同文件
                },
                header: {
                  token: localStorage.getItem('token')
                },
                srcList: [''],
                USER_code: USER,
                USER_search: USER_SEARCH,
                action: UPLOAD_API + UPLOAD_PATH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                esignRecordState: 'add',
                esignRecordStates: {
                    add: '新建签约',
                    check: '查看签约',
                    edit: '修改签约'
                },

                multipleSelection: [],
                esignRecordList: [],
                esignRecord: {
                    id: '', //ID
                    userId: '', //用户
                    contractId: '', //合同
                    textFields: '', //文本字段
                    signImage: '', //签名图片
                    stampImage: '', //签章图片
                    contractFile: '', //合同文件
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    contractId: [{ required: true, message: '合同不能为空', trigger: 'blur' }],
                    textFields: [{ required: true, message: '文本字段不能为空', trigger: 'blur' }],
                    signImage: [{ required: true, message: '签名图片不能为空', trigger: 'blur' }],
                    stampImage: [{ required: true, message: '签章图片不能为空', trigger: 'blur' }],
                    contractFile: [{ required: true, message: '合同文件不能为空', trigger: 'blur' }],
                },
                AgentLevelAll: []
            };
        },
        created() {
            this.getEsignRecordList();
            this.getList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            items(val){
              let array = val.replace(/&quot;/g, '"');
              console.log(array)
              array = JSON.parse(array)
              return array
            },
            // 下载文件
            downloadFile(url, fileName) {
              var anchorElement = document.createElement('a');
              anchorElement.href = url;
              anchorElement.download = fileName;
              anchorElement.target = "_blank";
              anchorElement.style.display = "none";
              document.body.appendChild(anchorElement);
              anchorElement.click();
              document.body.removeChild(anchorElement);
            },
            getTextFieldValue(val){
              console.log(val)
              this.esignRecord.textFields = val;
            },
            getList(){
              get('esign/contract/findAll', {
              }).then((res) => {
                  if (res.success) {
                      // console.log(res.enumList)
                      this.AgentLevelAll = res.list
                  }
              })
            },
            returnGetList(val){
              for (const key in this.AgentLevelAll) {
                if (this.AgentLevelAll[key].id ==  val) {
                  return this.AgentLevelAll[key].contractName;
                }
              }
            },
            updateSrcList(res){
              this.srcList[0] = res;
            },
            getValue(val){
              this.esignRecord.userId = val;
            },
            getValue1(val){
              this.queryForm.userId = val;
            },
            //上传缩略图
            uploadImage(params) {
              const file = params.file;
              let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
              if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
              }
              const formData = new FormData();
              formData.append('file', file);
              upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                  this.esignRecord.signImage = res.url;
                }
              });
            },
            //上传缩略图
            uploadImage1(params) {
              const file = params.file;
              let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
              if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
              }
              const formData = new FormData();
              formData.append('file', file);
              upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                  this.esignRecord.stampImage = res.url;
                }
              });
            },
            //上传文件
            uploadImage2(params) {
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              upload('/mpp/file/upload', formData).then((res) => {
                if (res.success) {
                  this.esignRecord.contractFile = res.url;
                }else{
                  this.$message.error(res.msg);
                }
              });
            },
            resetEsignRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.esignRecordList = [];
            },
            beforeImageUpload(file) {
              const isLt2M = file.size / 1024 / 1024 < 50;
              if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
              }
              return isLt2M;
            },
            beforeImageUpload1(file) {
              const isLt2M = file.size / 1024 / 1024 < 500;
              if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 500MB!');
              }
              return isLt2M;
            },
            resetDialog() {
                this.esignRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      contractId: '', //合同
                      textFields: '', //文本字段
                      signImage: '', //签名图片
                      stampImage: '', //签章图片
                      contractFile: '', //合同文件
                };
                this.getEsignRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.esignRecord = {
                      id: '', //ID
                      userId: '', //用户
                      contractId: '', //合同
                      textFields: '', //文本字段
                      signImage: '', //签名图片
                      stampImage: '', //签章图片
                      contractFile: '', //合同文件
                };
            },
            submitForm() {
                if (this.esignRecordState == 'add') {
                    this.$refs.esignRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/esign/record/add`,{ ...this.esignRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEsignRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.esignRecordState == 'edit') {
                    this.$refs.esignRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let obj = JSON.parse(JSON.stringify(this.esignRecord));
                            obj.textFields = obj.textFields.replace(/&quot;/g, '"');;
                            post(`/esign/record/edit`,{ ...obj }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEsignRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEsignRecord() {
                this.showDialog = true;
                this.esignRecordState = 'add';
            },
            checkEsignRecord(esignRecordId) {
                console.log(esignRecordId);
                this.currentEsignRecordId = esignRecordId;

                this.getEsignRecordById();
                this.showDialog = true;
                this.esignRecordState = 'check';
            },
            editEsignRecord(esignRecordId) {
                console.log('esignRecord', esignRecordId);
                if (esignRecordId) {
                    this.currentEsignRecordId = esignRecordId;
                    this.getEsignRecordById();
                } else {
                    this.esignRecord = { ...this.esignRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.esignRecordState = 'edit';
            },
            deleteEsignRecord(esignRecordId) {
                let ids = '';
                if (esignRecordId) {
                    ids = esignRecordId;
                } else {
                    ids = this.multipleSelection.map((esignRecord) => esignRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/esign/record/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEsignRecordList();
                                this.getEsignRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEsignRecordList() {
                this.resetEsignRecordList();
                this.getEsignRecordList();
            },
            getEsignRecordList(query = {}) {
                this.loading = true;
                get(`/esign/record/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.esignRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEsignRecordById() {
                get(`/esign/record/get`,{ id: this.currentEsignRecordId }).then((res) =>{
                    if(res.success){
                      this.esignRecord = { ...this.esignRecord, ...res.esignRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEsignRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/esign/record/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/esign/record/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/esign/record/importData`,formData);
              this.refreshEsignRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEsignRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEsignRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.avatar {
  width: 180px;
  height: 180px;
  display: block;
}

::v-deep .el-upload--text {
  width: 180px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 180px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.downloadFile{
    cursor: pointer;
}
.downloadFile:hover{
    color: #409eff;
}
</style>